export const LOGIN_FORM_LABELS = {
  EMAIL_ERROR: {
    required: 'Email is required',
    validEmail: 'Please enter a valid email address',
  },
  PASSWORD_ERROR: {
    required: 'Password is required',
  },
};
